import { STATUS_CLOSED, STATUS_OPEN, STATUS_WIP, STATUS_NREL, COLORS } from "./excel-constants";

/**
 * Handles all cell formatting operations
 */
export class ExcelFormatter {
  constructor(workSheet) {
    this.workSheet = workSheet;
  }

  /**
   * Adds percentage formatting to a cell
   */
  addNumberFormatting(cell) {
    this.workSheet.getCell(cell).numFmt = "0%";
  }

  /**
   * Adds percentage formatting with one decimal place (for more granular values)
   */
  addNumberFormatting1dp(cell) {
    this.workSheet.getCell(cell).numFmt = "0.0%";
  }

  /**
   * Adds data bar formatting to a range of cells
   */
  addDataBarFormatting(range) {
    this.workSheet.addConditionalFormatting({
      ref: range,
      rules: [
        {
          type: "dataBar",
          color: { argb: COLORS.DATA_BAR.fill },
          gradient: false,
          cfvo: [
            { type: "num", value: 0 },
            { type: "num", value: 1 },
          ],
          style: {
            font: { color: { argb: COLORS.DATA_BAR.font } },
          },
        },
      ],
    });
  }

  /**
   * Adds color formatting based on status value
   */
  addStatusColorFormatting(targetCell) {
    const statuses = [
      { value: STATUS_CLOSED, colors: COLORS.CLOSED },
      { value: STATUS_OPEN, colors: COLORS.OPEN },
      { value: STATUS_WIP, colors: COLORS.WIP },
      { value: STATUS_NREL, colors: { bg: "", font: "" } },
    ];

    statuses.forEach(({ value, colors }) => {
      this.workSheet.addConditionalFormatting({
        ref: targetCell,
        rules: [
          {
            type: "cellIs",
            operator: "equal",
            formulae: [`"${value}"`],
            style: {
              fill: {
                type: "pattern",
                pattern: "solid",
                bgColor: { argb: colors.bg },
              },
              font: colors.font ? { color: { argb: colors.font } } : {},
            },
          },
        ],
      });
    });
  }

  /**
   * Formats the summary row with data bars and percentages
   */
  formatSummaryRow(startCol, endCol, props) {
    const offset = 3 + props.responsibles.length;
    const firstColLetter = this.workSheet._columns[offset].letter;
    const lastColLetter = this.workSheet._columns[offset + props.steps.length].letter;

    // Add data bar
    this.addDataBarFormatting(`${firstColLetter}1:${lastColLetter}1`);

    // Add percentage formatting
    for (let i = offset; i <= offset + props.steps.length; i++) {
      const colLetter = this.workSheet._columns[i].letter;
      this.addNumberFormatting(`${colLetter}1`);
    }
  }

  /**
   * Formats fulfillment column with data bars and percentages
   */
  formatFulfillmentColumn(columnLetter, rowCount) {
    const startRow = 3;
    const endRow = startRow + rowCount - 1;

    this.addDataBarFormatting(`${columnLetter}${startRow}:${columnLetter}${endRow}`);

    for (let i = 0; i < rowCount; i++) {
      this.addNumberFormatting(`${columnLetter}${startRow + i}`);
    }
  }

  /**
   * Adds dropdown validation and color formatting to status cells
   */
  addStatusDropdown(targetCell) {
    this.workSheet.getCell(targetCell).dataValidation = {
      type: "list",
      allowBlank: true,
      formulae: [`"${STATUS_OPEN},${STATUS_WIP},${STATUS_CLOSED},${STATUS_NREL}"`],
    };
    this.addStatusColorFormatting(targetCell);
  }
}
